import { render, staticRenderFns } from "./DailyMilkRecordingList.vue?vue&type=template&id=fa480c22&"
import script from "./DailyMilkRecordingList.vue?vue&type=script&lang=js&"
export * from "./DailyMilkRecordingList.vue?vue&type=script&lang=js&"
import style0 from "./DailyMilkRecordingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports